import React, { useState } from "react";
import "./Contenido.css";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const conjuntos = [
    {
        title: "Casa Club P.C, Chapala Jalisco",
        cover: "/assets/images/1_CONJUNTO_PUNTO_CIELO/01.png",
        images: [
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/01.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/02.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/03.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/04.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/05.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/06.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/07.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/08.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/09.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/10.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/11.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/12.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/13.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/14.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/15.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/16.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/17.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/18.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/19.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/20.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/21.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/22.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/23.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/24.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/25.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/26.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/27.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/28.png",
            "/assets/images/1_CONJUNTO_PUNTO_CIELO/29.png",
        ],
    },
    {
        title: "Conjunto Ornelas, Cabo San Lucas B.C.S",
        cover: "/assets/images/2_CONJUNTO_ORNELAS/01.png",
        images: [
            "/assets/images/2_CONJUNTO_ORNELAS/01.png",
            "/assets/images/2_CONJUNTO_ORNELAS/02.png",
            "/assets/images/2_CONJUNTO_ORNELAS/03.png",
            "/assets/images/2_CONJUNTO_ORNELAS/04.png",
            "/assets/images/2_CONJUNTO_ORNELAS/05.png",
        ],
    },
    {
        title: "Valley View, Texas EUA",
        cover: "/assets/images/3_CONJUNTO_TEXAS/01.png",
        images: [
            "/assets/images/3_CONJUNTO_TEXAS/01.png",
            "/assets/images/3_CONJUNTO_TEXAS/02.png",
            "/assets/images/3_CONJUNTO_TEXAS/03.png",
            "/assets/images/3_CONJUNTO_TEXAS/04.png",
        ],
    },
    {
        title: "Amsterdam, Torreón Coahuila",
        cover: "/assets/images/4_ESTUDIOS_AMSTERDAM/01.png",
        images: [
            "/assets/images/4_ESTUDIOS_AMSTERDAM/01.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/02.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/03.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/04.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/05.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/06.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/07.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/08.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/09.png",
            "/assets/images/4_ESTUDIOS_AMSTERDAM/10.png",
        ],
    },
    {
        title: "Estudios Chulavista, Los Cabos B.C.S",
        cover: "/assets/images/5_ESTUDIOS_CHULAVISTA/01.png",
        images: [
            "/assets/images/5_ESTUDIOS_CHULAVISTA/01.png",
            "/assets/images/5_ESTUDIOS_CHULAVISTA/02.png",
            "/assets/images/5_ESTUDIOS_CHULAVISTA/03.png",
            "/assets/images/5_ESTUDIOS_CHULAVISTA/04.png",
            "/assets/images/5_ESTUDIOS_CHULAVISTA/05.png",
            "/assets/images/5_ESTUDIOS_CHULAVISTA/06.png",

        ],
    },
    {
        title: "Hotel Mariamar, Los Cabos B.C.S",
        cover: "/assets/images/6_ESTUDIOS_MARIAMAR/01.png",
        images: [
            "/assets/images/6_ESTUDIOS_MARIAMAR/01.png",
            "/assets/images/6_ESTUDIOS_MARIAMAR/02.png",
            "/assets/images/6_ESTUDIOS_MARIAMAR/03.png",
            "/assets/images/6_ESTUDIOS_MARIAMAR/04.png",
            "/assets/images/6_ESTUDIOS_MARIAMAR/05.png",

        ],
    },
    {
        title: "Estudios Costa Azul, Los Cabos B.C.S",
        cover: "/assets/images/7_HOTEL_COSTA_AZUL/01.png",
        images: [
            "/assets/images/7_HOTEL_COSTA_AZUL/01.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/02.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/03.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/04.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/05.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/06.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/07.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/08.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/09.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/10.png",
            "/assets/images/7_HOTEL_COSTA_AZUL/11.png",

        ],
    },
];

const viviendas = [
    {
        title: "Cabaña Jerez, Mazamitla Jalisco",
        cover: "/assets/images/VIVIENDA/1_CABAÑA_MAZAMITLA/01.png",
        images: [
            "/assets/images/VIVIENDA/1_CABAÑA_MAZAMITLA/01.png",
            "/assets/images/VIVIENDA/1_CABAÑA_MAZAMITLA/02.png",
            "/assets/images/VIVIENDA/1_CABAÑA_MAZAMITLA/03.png",
            "/assets/images/VIVIENDA/1_CABAÑA_MAZAMITLA/04.png",
            "/assets/images/VIVIENDA/1_CABAÑA_MAZAMITLA/05.png",

        ],
    },
    {
        title: "Casa Susana, Los Cabos B.C.S",
        cover: "/assets/images/VIVIENDA/2_CASA_SUSANA/01.png",
        images: [
            "/assets/images/VIVIENDA/2_CASA_SUSANA/01.png",
            "/assets/images/VIVIENDA/2_CASA_SUSANA/02.png",
            "/assets/images/VIVIENDA/2_CASA_SUSANA/03.png",
        ],
    },
    {
        title: "Casa Chanty, Los Cabos B.C.S",
        cover: "/assets/images/VIVIENDA/3_CASA_CHANTY/01.png",
        images: [
            "/assets/images/VIVIENDA/3_CASA_CHANTY/01.png",
            "/assets/images/VIVIENDA/3_CASA_CHANTY/02.png",
            "/assets/images/VIVIENDA/3_CASA_CHANTY/03.png",
            "/assets/images/VIVIENDA/3_CASA_CHANTY/04.png",
        ],
    },
    {
        title: "Casa Andrómeda, Chapala Jalisco",
        cover: "/assets/images/VIVIENDA/4_PROTOTIPO_ANDROMEDA/01.png",
        images: [
            "/assets/images/VIVIENDA/4_PROTOTIPO_ANDROMEDA/01.png",
            "/assets/images/VIVIENDA/4_PROTOTIPO_ANDROMEDA/02.png",
            "/assets/images/VIVIENDA/4_PROTOTIPO_ANDROMEDA/03.png",
            "/assets/images/VIVIENDA/4_PROTOTIPO_ANDROMEDA/04.png",
            "/assets/images/VIVIENDA/4_PROTOTIPO_ANDROMEDA/05.png",
            "/assets/images/VIVIENDA/4_PROTOTIPO_ANDROMEDA/06.png",
        ],
    },
    {
        title: "Casa Frank, Los Cabos B.C.S",
        cover: "/assets/images/VIVIENDA/5_CASA_FRANK/01.png",
        images: [
            "/assets/images/VIVIENDA/5_CASA_FRANK/01.png",
            "/assets/images/VIVIENDA/5_CASA_FRANK/02.png",
            "/assets/images/VIVIENDA/5_CASA_FRANK/03.png",
            "/assets/images/VIVIENDA/5_CASA_FRANK/04.png",

        ],
    },
    {
        title: "Casa Orión, Chapala Jalisco",
        cover: "/assets/images/VIVIENDA/6_PROTOTIPO_ORION/01.png",
        images: [
            "/assets/images/VIVIENDA/6_PROTOTIPO_ORION/01.png",
            "/assets/images/VIVIENDA/6_PROTOTIPO_ORION/02.png",
            "/assets/images/VIVIENDA/6_PROTOTIPO_ORION/03.png",
            "/assets/images/VIVIENDA/6_PROTOTIPO_ORION/04.png",
            "/assets/images/VIVIENDA/6_PROTOTIPO_ORION/05.png",
            "/assets/images/VIVIENDA/6_PROTOTIPO_ORION/06.png",

        ],
    },
    {
        title: "Casa Villa Gómez, Tehuacán Puebla",
        cover: "/assets/images/VIVIENDA/7_CASA_VILLA_GOMEZ/01.png",
        images: [
            "/assets/images/VIVIENDA/7_CASA_VILLA_GOMEZ/01.png",
            "/assets/images/VIVIENDA/7_CASA_VILLA_GOMEZ/02.png",
            "/assets/images/VIVIENDA/7_CASA_VILLA_GOMEZ/03.png",
            "/assets/images/VIVIENDA/7_CASA_VILLA_GOMEZ/04.png",
            "/assets/images/VIVIENDA/7_CASA_VILLA_GOMEZ/05.png",

        ],
    },
    {
        title: "Casa Viñedos, Torreón Coahuila ",
        cover: "/assets/images/VIVIENDA/8_CASA_VIÑEDOS/01.png",
        images: [
            "/assets/images/VIVIENDA/8_CASA_VIÑEDOS/01.png",
            "/assets/images/VIVIENDA/8_CASA_VIÑEDOS/02.png",

        ],
    },
    {
        title: "Casa Centauro, Chapala Jalisco",
        cover: "/assets/images/VIVIENDA/9_PROTOTIPO_CENTAURO/01.png",
        images: [
            "/assets/images/VIVIENDA/9_PROTOTIPO_CENTAURO/01.png",
            "/assets/images/VIVIENDA/9_PROTOTIPO_CENTAURO/02.png",
            "/assets/images/VIVIENDA/9_PROTOTIPO_CENTAURO/03.png",
            "/assets/images/VIVIENDA/9_PROTOTIPO_CENTAURO/04.png",
            "/assets/images/VIVIENDA/9_PROTOTIPO_CENTAURO/05.png",

        ],
    },
    {
        title: "Casa Vega, Chapala Jalisco",
        cover: "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/01.png",
        images: [
            "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/01.png",
            "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/02.png",
            "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/03.png",
            "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/04.png",
            "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/05.png",
            "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/06.png",
            "/assets/images/VIVIENDA/10_PROTOTIPO_VEGA/07.png",

        ],
    },
    {
        title: "Casa Canopus, Chapala Jalisco",
        cover: "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/01.png",
        images: [
            "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/01.png",
            "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/02.png",
            "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/03.png",
            "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/04.png",
            "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/05.png",
            "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/06.png",
            "/assets/images/VIVIENDA/11_PROTOTIPO_CANOPUS/07.png",

        ],
    },
    {
        title: "Casa Esmeralda, Silao Gto",
        cover: "/assets/images/VIVIENDA/12_CASA_ESMERALDA/01.png",
        images: [
            "/assets/images/VIVIENDA/12_CASA_ESMERALDA/01.png",
            "/assets/images/VIVIENDA/12_CASA_ESMERALDA/02.png",
            "/assets/images/VIVIENDA/12_CASA_ESMERALDA/03.png",
            "/assets/images/VIVIENDA/12_CASA_ESMERALDA/04.png",
            "/assets/images/VIVIENDA/12_CASA_ESMERALDA/05.png",

        ],
    },
    {
        title: "Casa Barré, Acatlán Hidalgo",
        cover: "/assets/images/VIVIENDA/13_CASA_BARRE/01.png",
        images: [
            "/assets/images/VIVIENDA/13_CASA_BARRE/01.png",
            "/assets/images/VIVIENDA/13_CASA_BARRE/02.png",
            "/assets/images/VIVIENDA/13_CASA_BARRE/03.png",

        ],
    },
    {
        title: "Casa Saldierna, Cd. Victoria Tamaulipas",
        cover: "/assets/images/VIVIENDA/14_CASA_SALDIERNA/01.png",
        images: [
            "/assets/images/VIVIENDA/14_CASA_SALDIERNA/01.png",
            "/assets/images/VIVIENDA/14_CASA_SALDIERNA/02.png",
            "/assets/images/VIVIENDA/14_CASA_SALDIERNA/03.png",
            "/assets/images/VIVIENDA/14_CASA_SALDIERNA/04.png",
            "/assets/images/VIVIENDA/14_CASA_SALDIERNA/05.png",
            "/assets/images/VIVIENDA/14_CASA_SALDIERNA/06.png",

        ],
    },
    {
        title: "Casa Casiopea, Chapala Jalisco",
        cover: "/assets/images/VIVIENDA/15_PROTOTIPO_CASIOPEA/01.png",
        images: [
            "/assets/images/VIVIENDA/15_PROTOTIPO_CASIOPEA/01.png",
            "/assets/images/VIVIENDA/15_PROTOTIPO_CASIOPEA/02.png",
            "/assets/images/VIVIENDA/15_PROTOTIPO_CASIOPEA/03.png",
            "/assets/images/VIVIENDA/15_PROTOTIPO_CASIOPEA/04.png",
            "/assets/images/VIVIENDA/15_PROTOTIPO_CASIOPEA/05.png",

        ],
    },
    {
        title: "Casa Sirio, Chapala Jalisco",
        cover: "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/01.png",
        images: [
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/01.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/02.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/03.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/04.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/05.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/06.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/07.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/08.png",
            "/assets/images/VIVIENDA/16_PROTOTIPO_SIRIO/09.png",

        ],
    },
];

const residencias = [
    {
        title: "Casa Rancho San Juan, Atizapán de Zaragoza Edo. Mex",
        cover: "/assets/images/RESIDENCIAS/1_CASA_RSJ/01.png",
        images: [
            "/assets/images/RESIDENCIAS/1_CASA_RSJ/01.png",
            "/assets/images/RESIDENCIAS/1_CASA_RSJ/02.png",
            "/assets/images/RESIDENCIAS/1_CASA_RSJ/03.png",
            "/assets/images/RESIDENCIAS/1_CASA_RSJ/04.png",
            "/assets/images/RESIDENCIAS/1_CASA_RSJ/05.png",
            "/assets/images/RESIDENCIAS/1_CASA_RSJ/06.png",

        ],
    },
    {
        title: "Casa Hip, Valle de Bravo Edo. Mex",
        cover: "/assets/images/RESIDENCIAS/2_CASA_HIP/01.png",
        images: [
            "/assets/images/RESIDENCIAS/2_CASA_HIP/01.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/02.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/03.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/04.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/05.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/06.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/07.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/08.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/09.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/10.png",
            "/assets/images/RESIDENCIAS/2_CASA_HIP/11.png",

        ],
    },
    {
        title: "Conjunto Costa Azul, Los Cabos B.C.S",
        cover: "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/01.png",
        images: [
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/01.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/02.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/03.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/04.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/05.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/06.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/07.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/08.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/09.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/10.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/11.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/12.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/13.png",
            "/assets/images/RESIDENCIAS/3_CONJUNTO_COSTA_AZUL/14.png",

        ],
    },
    {
        title: "Casa Deanne, Los Cabos B.C.S",
        cover: "/assets/images/RESIDENCIAS/4_CASA_DEANNE/01.png",
        images: [
            "/assets/images/RESIDENCIAS/4_CASA_DEANNE/01.png",
            "/assets/images/RESIDENCIAS/4_CASA_DEANNE/02.png",
            "/assets/images/RESIDENCIAS/4_CASA_DEANNE/03.png",
            "/assets/images/RESIDENCIAS/4_CASA_DEANNE/04.png",

        ],
    },
    {
        title: "La Rivera, Los Cabos B.C.S",
        cover: "/assets/images/RESIDENCIAS/5_CASA_RIVERA/01.png",
        images: [
            "/assets/images/RESIDENCIAS/5_CASA_RIVERA/01.png",
            "/assets/images/RESIDENCIAS/5_CASA_RIVERA/02.png",
            "/assets/images/RESIDENCIAS/5_CASA_RIVERA/03.png",
            "/assets/images/RESIDENCIAS/5_CASA_RIVERA/04.png",
            "/assets/images/RESIDENCIAS/5_CASA_RIVERA/05.png",

        ],
    },
    {
        title: "Casa Heat, Texas EUA",
        cover: "/assets/images/RESIDENCIAS/6_CASA_HEAT/01.png",
        images: [
            "/assets/images/RESIDENCIAS/6_CASA_HEAT/01.png",
            "/assets/images/RESIDENCIAS/6_CASA_HEAT/02.png",
            "/assets/images/RESIDENCIAS/6_CASA_HEAT/03.png",
            "/assets/images/RESIDENCIAS/6_CASA_HEAT/04.png",
            "/assets/images/RESIDENCIAS/6_CASA_HEAT/05.png",
            "/assets/images/RESIDENCIAS/6_CASA_HEAT/06.png",

        ],
    },
    {
        title: "Casa Emerson, Los Cabos B.C.S",
        cover: "/assets/images/RESIDENCIAS/7_CASA_EMERSON/01.png",
        images: [
            "/assets/images/RESIDENCIAS/7_CASA_EMERSON/01.png",
            "/assets/images/RESIDENCIAS/7_CASA_EMERSON/02.png",
            "/assets/images/RESIDENCIAS/7_CASA_EMERSON/03.png",
            "/assets/images/RESIDENCIAS/7_CASA_EMERSON/04.png",
            "/assets/images/RESIDENCIAS/7_CASA_EMERSON/05.png",
            "/assets/images/RESIDENCIAS/7_CASA_EMERSON/06.png",
            "/assets/images/RESIDENCIAS/7_CASA_EMERSON/07.png",

        ],
    },
    {
        title: "Remodelación Mattawa, Washington EUA",
        cover: "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/01.png",
        images: [
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/01.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/02.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/03.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/04.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/05.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/06.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/07.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/08.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/09.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/10.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/11.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/12.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/13.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/14.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/15.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/16.png",
            "/assets/images/RESIDENCIAS/8_CASA_MATTAWA/17.png",

        ],
    },
    {
        title: "Casa Karen, Querétaro Qro.",
        cover: "/assets/images/RESIDENCIAS/9_CASA_KAREN/01.png",
        images: [
            "/assets/images/RESIDENCIAS/9_CASA_KAREN/01.png",
            "/assets/images/RESIDENCIAS/9_CASA_KAREN/02.png",
            "/assets/images/RESIDENCIAS/9_CASA_KAREN/03.png",
            "/assets/images/RESIDENCIAS/9_CASA_KAREN/04.png",
            "/assets/images/RESIDENCIAS/9_CASA_KAREN/05.png",
            "/assets/images/RESIDENCIAS/9_CASA_KAREN/06.png",
            "/assets/images/RESIDENCIAS/9_CASA_KAREN/07.png",

        ],
    },
    {
        title: "Interiorismo casa Escandinavia, Texas EUA",
        cover: "/assets/images/RESIDENCIAS/10_CASA_ESCANDINAVIA/01.png",
        images: [
            "/assets/images/RESIDENCIAS/10_CASA_ESCANDINAVIA/01.png",
            "/assets/images/RESIDENCIAS/10_CASA_ESCANDINAVIA/03.png",
            "/assets/images/RESIDENCIAS/10_CASA_ESCANDINAVIA/04.png",

        ],
    },
    {
        title: "Casa Morelos, Oaxtepec Morelos",
        cover: "/assets/images/RESIDENCIAS/11_CASA_MORELOS/01.png",
        images: [
            "/assets/images/RESIDENCIAS/11_CASA_MORELOS/01.png",
            "/assets/images/RESIDENCIAS/11_CASA_MORELOS/02.png",
            "/assets/images/RESIDENCIAS/11_CASA_MORELOS/03.png",
            "/assets/images/RESIDENCIAS/11_CASA_MORELOS/04.png",
            "/assets/images/RESIDENCIAS/11_CASA_MORELOS/05.png",
            "/assets/images/RESIDENCIAS/11_CASA_MORELOS/06.png",
            "/assets/images/RESIDENCIAS/11_CASA_MORELOS/07.png",

        ],
    },
    {
        title: "Casa Lety, La Paz B.C.S",
        cover: "/assets/images/RESIDENCIAS/12_CASA_LETY/01.png",
        images: [
            "/assets/images/RESIDENCIAS/12_CASA_LETY/01.png",
            "/assets/images/RESIDENCIAS/12_CASA_LETY/02.png",
            "/assets/images/RESIDENCIAS/12_CASA_LETY/03.png",
            "/assets/images/RESIDENCIAS/12_CASA_LETY/04.png",
            "/assets/images/RESIDENCIAS/12_CASA_LETY/05.png",

        ],
    },
    {
        title: "Interiorismo Tudor, Texas EUA",
        cover: "/assets/images/RESIDENCIAS/13_CASA_TUDOR/02.png",
        images: [

            "/assets/images/RESIDENCIAS/13_CASA_TUDOR/02.png",
            "/assets/images/RESIDENCIAS/13_CASA_TUDOR/03.png",
            "/assets/images/RESIDENCIAS/13_CASA_TUDOR/04.png",
            "/assets/images/RESIDENCIAS/13_CASA_TUDOR/05.png",
            "/assets/images/RESIDENCIAS/13_CASA_TUDOR/06.png",
            "/assets/images/RESIDENCIAS/13_CASA_TUDOR/07.png",

        ],
    },
    {
        title: "Casa Estrada, Querétaro Qro",
        cover: "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/01.png",
        images: [
            "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/01.png",
            "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/02.png",
            "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/03.png",
            "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/04.png",
            "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/05.png",
            "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/06.png",
            "/assets/images/RESIDENCIAS/14_CASA_ESTRADA/07.png",

        ],
    },
];

const comercial = [
    {
        title: "Alberca Olímpica, Ciudad de México",
        cover: "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/01.png",
        images: [
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/01.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/02.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/03.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/04.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/05.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/06.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/07.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/08.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/09.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/10.png",
            "/assets/images/COMERCIAL/1_ALBERCA_OLIMPICA/11.png",

        ],
    },
    {
        title: "La Gran Muralla, La Paz B.C.S",
        cover: "/assets/images/COMERCIAL/2_LA_GRAN_MURALLA/01.png",
        images: [
            "/assets/images/COMERCIAL/2_LA_GRAN_MURALLA/01.png",
            "/assets/images/COMERCIAL/2_LA_GRAN_MURALLA/02.png",

        ],
    },
    {
        title: "Plaza 20 de Noviembre, Los Cabos B.C.S",
        cover: "/assets/images/COMERCIAL/3_PLAZA_20_NOVIEMBRE/01.png",
        images: [
            "/assets/images/COMERCIAL/3_PLAZA_20_NOVIEMBRE/01.png",
            "/assets/images/COMERCIAL/3_PLAZA_20_NOVIEMBRE/02.png",
            "/assets/images/COMERCIAL/3_PLAZA_20_NOVIEMBRE/03.png",
            "/assets/images/COMERCIAL/3_PLAZA_20_NOVIEMBRE/04.png",

        ],
    },
    {
        title: "Plaza Carolina, Guasave Sinaloa",
        cover: "/assets/images/COMERCIAL/4_PLAZA_CAROLINA/01.png",
        images: [
            "/assets/images/COMERCIAL/4_PLAZA_CAROLINA/01.png",
            "/assets/images/COMERCIAL/4_PLAZA_CAROLINA/02.png",
            "/assets/images/COMERCIAL/4_PLAZA_CAROLINA/03.png",
            "/assets/images/COMERCIAL/4_PLAZA_CAROLINA/04.png",
            "/assets/images/COMERCIAL/4_PLAZA_CAROLINA/05.png",

        ],
    },
    {
        title: "Plaza Fresno, Torreón Coahuila",
        cover: "/assets/images/COMERCIAL/5_PLAZA_FRESNO/01.png",
        images: [
            "/assets/images/COMERCIAL/5_PLAZA_FRESNO/01.png",
            "/assets/images/COMERCIAL/5_PLAZA_FRESNO/02.png",

        ],
    },
    {
        title: "Plaza Zaragoza, Los Cabos B.C.S",
        cover: "/assets/images/COMERCIAL/6_PLAZA_ZARAGOZA/01.png",
        images: [
            "/assets/images/COMERCIAL/6_PLAZA_ZARAGOZA/01.png",
            "/assets/images/COMERCIAL/6_PLAZA_ZARAGOZA/02.png",
            "/assets/images/COMERCIAL/6_PLAZA_ZARAGOZA/03.png",
            "/assets/images/COMERCIAL/6_PLAZA_ZARAGOZA/04.png",
            "/assets/images/COMERCIAL/6_PLAZA_ZARAGOZA/05.png",

        ],
    },
    {
        title: "Restaurante PIIH, Guadalajara Jalisco",
        cover: "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/01.png",
        images: [
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/01.png",
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/02.png",
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/03.png",
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/04.png",
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/05.png",
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/06.png",
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/07.png",
            "/assets/images/COMERCIAL/7_RESTAURANTE_PIIH/08.png",

        ],
    },
    {
        title: "Estética W Salón, La Paz B.C.S",
        cover: "/assets/images/COMERCIAL/8_W_SALON/01.png",
        images: [
            "/assets/images/COMERCIAL/8_W_SALON/01.png",
            "/assets/images/COMERCIAL/8_W_SALON/02.png",
            "/assets/images/COMERCIAL/8_W_SALON/03.png",
            "/assets/images/COMERCIAL/8_W_SALON/04.png",
            "/assets/images/COMERCIAL/8_W_SALON/05.png",

        ],
    },

];

function Contenido() {
    const [selectedProject, setSelectedProject] = useState(null);
    const [currentImageIndex, setCurrentImageIndex] = useState(0);

    const openProject = (project) => {
        setSelectedProject(project);
        setCurrentImageIndex(0);
    };

    const closeProject = () => {
        setSelectedProject(null);
        setCurrentImageIndex(0);
    };

    const nextImage = () => {
        if (!selectedProject) return;
        setCurrentImageIndex((prev) =>
            prev === selectedProject.images.length - 1 ? 0 : prev + 1
        );
    };

    const prevImage = () => {
        if (!selectedProject) return;
        setCurrentImageIndex((prev) =>
            prev === 0 ? selectedProject.images.length - 1 : prev - 1
        );
    };

    return (
        <>
            <main className="contenido">
                <section className="hero-video">
                    <video
                        className="hero-video-element"
                        src="/assets/videos/hero.webm"
                        autoPlay
                        loop
                        muted
                        playsInline
                    />
                </section>

                <section className="conjuntos-section" id="conjuntos-habitacionales">
                    <div className="conjuntos-container">
                        <div className="conjuntos-texto">
                            <h2>CONJUNTOS HABITACIONALES</h2>
                            <p>
                                Entendemos el desarrollo inmobiliario como un equilibrio entre inversión, mercado y producto.
                            </p>
                            <p>
                                Desde la planeación hasta la visualización, buscamos convertir el proyecto en una propuesta tangible que facilite su comercialización.
                            </p>
                        </div>

                        <div className="conjuntos-grid">
                            {conjuntos.map((project, index) => (
                                <div
                                    key={index}
                                    className="conjuntos-item"
                                    onClick={() => openProject(project)}
                                >
                                    <img src={project.cover} alt={project.title} />
                                    <div className="overlay">
                                        <span>{project.title}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <section className="conjuntos-section" id="vivienda">
                    <div className="conjuntos-container">
                        <div className="conjuntos-texto">
                            <h2>VIVIENDA</h2>
                            <p>
                                Cada vivienda responde a una forma de vivir, pero también a una inversión que debe cuidarse.
                            </p>
                            <p>
                                Diseñamos proyectos claros, construibles y bien pensados, donde cada espacio tiene lógica y cada decisión tiene fundamento.
                            </p>
                        </div>

                        <div className="conjuntos-grid">
                            {viviendas.map((project, index) => (
                                <div
                                    key={index}
                                    className="conjuntos-item"
                                    onClick={() => openProject(project)}
                                >
                                    <img src={project.cover} alt={project.title} />
                                    <div className="overlay">
                                        <span>{project.title}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="conjuntos-section" id="residencias">
                    <div className="conjuntos-container">
                        <div className="conjuntos-texto">
                            <h2>RESIDENCIAS</h2>
                            <p>
                                Proyectos donde el diseño, la realización y el detalle compositivo reflejan una interpretación precisa del cliente.
                            </p>
                            <p>
                                No se trata de estilos, sino de lograr una arquitectura coherente, bien ejecutada y con carácter propio.
                            </p>
                        </div>

                        <div className="conjuntos-grid">
                            {residencias.map((project, index) => (
                                <div
                                    key={index}
                                    className="conjuntos-item"
                                    onClick={() => openProject(project)}
                                >
                                    <img src={project.cover} alt={project.title} />
                                    <div className="overlay">
                                        <span>{project.title}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="conjuntos-section" id="comercial-institucional">
                    <div className="conjuntos-container">
                        <div className="conjuntos-texto">
                            <h2>COMERCIAL E INSTITUCIONAL</h2>
                            <p>
                                Proyectos donde el diseño, la realización y el detalle compositivo reflejan una interpretación precisa del cliente.
                            </p>
                            <p>
                                No se trata de estilos, sino de lograr una arquitectura coherente, bien ejecutada y con carácter propio.
                            </p>
                        </div>

                        <div className="conjuntos-grid">
                            {comercial.map((project, index) => (
                                <div
                                    key={index}
                                    className="conjuntos-item"
                                    onClick={() => openProject(project)}
                                >
                                    <img src={project.cover} alt={project.title} />
                                    <div className="overlay">
                                        <span>{project.title}</span>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                {/* NOSOTROS */}
                <section className="nosotros-section" id="nosotros">
                    <div className="nosotros-container">
                        <h2>SOBRE ARQUITECTURA COMERCIAL</h2>

                        <p>
                            En <strong>Nextia + arqtect</strong> contamos con una sólida trayectoria en el ámbito de la arquitectura comercial. Desde 1987, hemos diseñado y construido más de 100 locales comerciales, lo que nos ha permitido adquirir una profunda experiencia y convertirnos en expertos en este sector.
                        </p>

                        <p>
                            Nuestra especialización en arquitectura comercial nos ha enseñado a entender las necesidades específicas de cada negocio y a crear espacios que no solo sean funcionales y atractivos, sino que también potencien la experiencia del cliente y contribuyan al éxito comercial. Trabajamos de la mano con nuestros clientes para desarrollar soluciones personalizadas que reflejen la identidad de su marca y se adapten al entorno competitivo actual.
                        </p>

                        <p>
                            A lo largo de más de tres décadas, hemos afrontado diversos desafíos y nos hemos mantenido a la vanguardia de las tendencias y tecnologías en diseño comercial. Nuestra dedicación y compromiso con la excelencia nos permiten ofrecer proyectos de alta calidad que cumplen con los más altos estándares estéticos y funcionales.
                        </p>


                        <h2>NOSOTROS</h2>

                        <p>
                            En Nextia + Arquitect somos un equipo multidisciplinario que aborda la arquitectura desde la experiencia, el criterio técnico y la viabilidad económica.
                        </p>

                        <p>
                            Entendemos que cada proyecto implica una inversión importante, por lo que nuestro enfoque no se limita al diseño, sino a la toma de decisiones correctas desde el inicio.
                        </p>

                        <p>
                            La diversidad de estilos y enfoques arquitectónicos que manejamos responde a nuestra comprensión de que cada cliente parte de un contexto cultural distinto, así como de preferencias estéticas propias. El dominio de la composición arquitectónica nos permite interpretar estos paradigmas y traducirlos en propuestas versátiles, capaces de adaptarse a distintos lenguajes formales sin perder coherencia ni calidad en el diseño.
                        </p>

                        <p>
                            Nuestro equipo está conformado por tres perfiles que complementan cada proyecto:
                        </p>

                        <p>
                            <strong>Arquitecto Salvador Barquín Noyola</strong>
                        </p>

                        <p>
                            Con más de 35 años de experiencia, aporta una base sólida en la ejecución de proyectos, asegurando soluciones técnicas, funcionales y constructivas bien resueltas.
                        </p>

                        <p>
                            <strong>Arquitecto Damián Barquín Desormaux</strong>
                        </p>

                        <p>
                            Aporta una visión contemporánea y urbana, entendiendo la arquitectura como un sistema que responde al contexto social, cultural y espacial de cada proyecto.
                        </p>

                        <p>
                            <strong>Mtro. en Ciencias Económicas Gabriel Barquín Desormaux</strong>
                        </p>

                        <p>
                            Integra el análisis financiero y estadístico del sector inmobiliario, evaluando la viabilidad y el impacto económico de cada decisión, fortaleciendo el proyecto como inversión.
                        </p>

                        <p>
                            Más que seguir estilos, interpretamos cada proyecto desde sus condiciones reales: el terreno, el presupuesto, el uso y el contexto.
                        </p>

                        <p>
                            Creemos que la buena arquitectura no solo debe verse bien, sino funcionar, construirse correctamente y responder a la inversión realizada.
                        </p>

                        <p>
                            Por ello, acompañamos a nuestros clientes más allá del diseño, brindando una asesoría integral que permite tomar decisiones con mayor certeza y claridad.
                        </p>
                    </div>
                </section>

                {/* CONTACTO */}
                <section className="contacto-section" id="contacto">
                    <div className="contacto-container">
                        <h2>CONTACTO</h2>

                        <p className="contacto-lead">
                            Cada proyecto implica decisiones importantes.
                        </p>

                        <p className="contacto-texto">
                            Si estás por construir o desarrollar y quieres hacerlo con mayor certeza, podemos ayudarte.
                        </p>

                        <div className="contacto-botones">
                            <a
                                className="contacto-boton whatsapp"
                                href="https://wa.me/4426158054?text=Hola%20Nextia%2C%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios."
                                target="_blank"
                                rel="noreferrer"
                            >
                                <span className="contacto-icono"><FontAwesomeIcon icon={faWhatsapp} size="lg" /></span>
                                <span>ENVIAR MENSAJE WHATSAPP</span>
                            </a>

                            <a
                                className="contacto-boton correo"
                                href="mailto:sal_barquin@hotmail.com?subject=Contacto%20desde%20sitio%20web&body=Hola%20Nextia%2C%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n."
                            >
                                <span className="contacto-icono">✉</span>
                                <span>ENVIAR MENSAJE CORREO</span>
                            </a>
                        </div>
                    </div>
                </section>

                <footer className="footer">
                    <div className="footer-container">

                        <div className="footer-brand">
                            <img src="/assets/logo.png" alt="Nextia Arquitectura" className="footer-logo" />
                            <p className="footer-tagline">
                                Arquitectura con criterio, identidad y viabilidad.
                            </p>
                        </div>

                        <div className="footer-links">
                            <h4>NAVEGACIÓN</h4>
                            <a href="#conjuntos-habitacionales">Conjuntos Habitacionales</a>
                            <a href="#vivienda">Vivienda</a>
                            <a href="#residencias">Residencias</a>
                            <a href="#comercial">Comercial e Institucional</a>
                            <a href="#nosotros">Nosotros</a>
                            <a href="#contacto">Contacto</a>
                        </div>

                        <div className="footer-contacto">
                            <h4>CONTACTO</h4>
                            <a href="https://wa.me/4426158054?text=Hola%20Nextia%2C%20me%20gustar%C3%ADa%20recibir%20informaci%C3%B3n%20sobre%20sus%20servicios." target="_blank" rel="noreferrer">
                                WhatsApp
                            </a>
                            <a href="mailto:sal_barquin@hotmail.com?subject=Contacto%20desde%20sitio%20web&body=Hola%20Nextia%2C%20me%20gustar%C3%ADa%20recibir%20m%C3%A1s%20informaci%C3%B3n.">
                                Correo
                            </a>
                            <a href="https://www.instagram.com/taller.arqtect/?fbclid=IwY2xjawG9e5VleHRuA2FlbQIxMAABHatC7I…" target="_blank" rel="noreferrer">
                                Instagram
                            </a>
                            <a href="https://www.facebook.com/render.arqtect" target="_blank" rel="noreferrer">
                                Facebook
                            </a>
                            <a href="https://www.tiktok.com/@tallerarqtect1" target="_blank" rel="noreferrer">
                                TikTok
                            </a>
                        </div>

                    </div>

                    <div className="footer-bottom">
                        <p>© 2026 Nextia + Arqtect. Todos los derechos reservados.</p>
                    </div>
                </footer>
            </main>

            {selectedProject && (
                <div className="modal-overlay" onClick={closeProject}>
                    <div
                        className="modal-content"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="close-btn" onClick={closeProject}>
                            ×
                        </button>

                        <button className="carousel-btn prev-btn" onClick={prevImage}>
                            ‹
                        </button>

                        <img
                            src={selectedProject.images[currentImageIndex]}
                            alt={selectedProject.title}
                            className="modal-image"
                        />

                        <button className="carousel-btn next-btn" onClick={nextImage}>
                            ›
                        </button>

                        <div className="modal-title">
                            {selectedProject.title}
                        </div>

                        <div className="modal-counter">
                            {currentImageIndex + 1} / {selectedProject.images.length}
                        </div>

                        <div className="modal-thumbs">
                            {selectedProject.images.map((img, index) => (
                                <img
                                    key={index}
                                    src={img}
                                    alt={`${selectedProject.title} ${index + 1}`}
                                    className={
                                        index === currentImageIndex
                                            ? "thumb active-thumb"
                                            : "thumb"
                                    }
                                    onClick={() => setCurrentImageIndex(index)}
                                />
                            ))}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}

export default Contenido;